import * as yup from 'yup';

export const schema = yup.object().shape({
    email: yup.string().required('Email is required field').email('Email must be valid'),
    subject: yup.string(),
    msg: yup.string(),
    isAgree: yup.boolean().required(),
});